// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ConfirmOrderFbCmp from "../shared/ConfirmOrderFbCmp.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as ConfirmOrderFormCmp from "./ConfirmOrderFormCmp.bs.js";
import * as PickAndDropSectionCmp from "../VehicleSelection/PickAndDropSectionCmp.bs.js";
import * as ConfirmOrderSuccessModalCmp from "./ConfirmOrderSuccessModalCmp.bs.js";

function ConfirmOrderCmp(Props) {
  var onClosePlaceOrderPanel = Props.onClosePlaceOrderPanel;
  var match = React.useState(function () {
        return "";
      });
  var setCRN = match[1];
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowModal = match$1[1];
  var match$2 = PlaceOrderContext.useContext(undefined);
  var dispatch = match$2.dispatch;
  var match$3 = React.useState(function () {
        return false;
      });
  var setLoading = match$3[1];
  var match$4 = React.useState(function () {
        return false;
      });
  var setAssignManually = match$4[1];
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* SetIsRebook */12,
                _0: false
              });
          
        }), []);
  return React.createElement("div", {
              className: "place_order_step__3"
            }, match$3[0] ? React.createElement(ConfirmOrderFbCmp.make, {}) : React.createElement(React.Fragment, undefined, React.createElement(PickAndDropSectionCmp.make, {}), React.createElement(ConfirmOrderFormCmp.make, {
                        vehicle: match$2.state.selectedVehicle,
                        onPlaceOrderSuccess: (function (data, assign_manually) {
                            Curry._1(setCRN, (function (param) {
                                    return data.order_crn;
                                  }));
                            Curry._1(setAssignManually, (function (param) {
                                    return assign_manually;
                                  }));
                            return Curry._1(setShowModal, (function (param) {
                                          return true;
                                        }));
                          }),
                        setLoading: (function (value) {
                            return Curry._1(setLoading, (function (param) {
                                          return value;
                                        }));
                          })
                      })), React.createElement(ConfirmOrderSuccessModalCmp.make, {
                  closeModal: (function (param) {
                      Curry._1(onClosePlaceOrderPanel, undefined);
                      return Curry._1(setShowModal, (function (param) {
                                    return false;
                                  }));
                    }),
                  crn: match[0],
                  showModal: match$1[0],
                  assignManually: match$4[0]
                }));
}

var make = ConfirmOrderCmp;

export {
  make ,
  
}
/* react Not a pure module */
